import { getAuthorizedApi } from "api/apiInstance";
import { baseInternalUrl } from "api/constants";
// import TextOrVideo from "components/TextOrVideo";
import { logger } from "logging/log-util";
// import HomePage from "components/homePage";
import { getSession } from "next-auth/react";
import dynamic from "next/dynamic";
// import { useDispatch, useSelector } from "react-redux";
// import { useEffect } from "react";
// import { allFeaturedData, allpostData } from "redux/actions/postAction";
// export const config = { amp: true }
// const HomePage = dynamic(() => import("../../components/homePage"), {
//   ssr: true,
// });
const TextOrVideo = dynamic(() => import("components/homePage/TextOrVideo"), {
  ssr: true,
});


// export const config = { amp: "hybrid" };
export default function Home(props) {
  // const dispatch = useDispatch();
  // const { allPosts, featuredPosts  } = useSelector(({PostReducer})=>PostReducer)
  // useEffect(() => {
  //   const contentType = "video";
  //   dispatch(allpostData({ contentType }));
  //   dispatch(allFeaturedData({ contentType }));
  // }, [dispatch]);

  return <TextOrVideo {...props}  />;
}
export async function getServerSideProps(ctx) {
  const session = await getSession(ctx);
  const lallantop = JSON.parse(ctx.req?.cookies?.lallantop || "{}");
  const httpClient = await getAuthorizedApi(lallantop.encryptedToken);
  try {
    const [
      latest,
      // storyShowData,
      ShortsResponse,
      topShowsWidgetDataResponse,
      authorData,
      topPodcast,
    ] = await Promise.all([
      httpClient.get(`${baseInternalUrl}/post/list?type=video&limit=12&skip=1`),
      // httpClient.post(`${baseInternalUrl}/story/filter`, {
      //   limit: 10,
      //   skip: 1,
      //   categories: [],
      // }),
      httpClient.post(`${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/short/list`, {
        limit: 12,
        skip: 1,
      }),
      httpClient.get(
        `${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/series/video-homepage?limit=10&skip=1&episodeLimit=5`
      ),
      httpClient.get(
        `${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/author/list?limit=22&skip=1`
      ),
      httpClient.get(
        `${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/spreaker/data?limit=1&topShow=false&topEpisode=true&skip=0`
      ),
    ]);
    let newsData = [];
    let shortsData = [];
    let topShowsWidgetData = [];
    let authorWidgetData = [];
    let topPodcastData = [];

    const { data } = await httpClient.get(
      `${baseInternalUrl}/series/topShows?limit=10&skip=1&type=video`
    );
    newsData = data?.result?.videoShows;
    if (authorData.data && authorData.data.result) {
      authorWidgetData = authorData.data.result.columnists;
      console.log("authorWidgetData", authorWidgetData);
    }
    if (topPodcast.data && topPodcast.data.result) {
      topPodcastData = topPodcast.data.result.podcasts.topEpisodes;
    }

    if (ShortsResponse.data && ShortsResponse.data.result) {
      shortsData = ShortsResponse.data.result.entities;
    }
    if (
      topShowsWidgetDataResponse?.data &&
      topShowsWidgetDataResponse?.data?.result?.videoShows
    ) {
      topShowsWidgetData = topShowsWidgetDataResponse?.data?.result?.videoShows;
    }
    try {
      ctx?.res?.setHeader("Cache-Control", `stale-if-error=86400`);
    } catch (error) {
      console.error("cache error", error);
    }
    return {
      props: {
        // session,
        NewsPageData: latest.data.result.categoryPosts[0],
        shortsData: shortsData,
        topShowsData: newsData,
        topShowsWidgetData: topShowsWidgetData,
        authorWidgetData,
        topPodcastData,
      }, // will be passed to the page component as props
    };
  } catch (error) {
    logger.error(error);
    return {
      props: {
        // session,
      },
    };
  }
}
